export { ResizedEvent, ResizedDirective } from './resized.directive';
